import { render, staticRenderFns } from "./NumberCircle.vue?vue&type=template&id=2a489127&scoped=true&"
import script from "./NumberCircle.vue?vue&type=script&lang=js&"
export * from "./NumberCircle.vue?vue&type=script&lang=js&"
import style0 from "./NumberCircle.vue?vue&type=style&index=0&id=2a489127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a489127",
  null
  
)

export default component.exports